// extracted by mini-css-extract-plugin
export default {"vendorsNav":"vendorsNav__NWMxY","overlay":"overlay__OGIwM","active":"active__ZWI2N"};